import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'getTileIcon' })
export class BmDashboardTileIconPipe implements PipeTransform {
  transform(item: any, type: string): string {
    if (item.iconType) return item.iconType;
    if (type === 'behaviorType') {
      return item.categoryId === 0 ? 'praise' : 'guidance';
    } else {
      return item.categoryId === 0 ? 'consequence-praise' : 'consequence-guidance';
    }
  }
}
